import { connectedStore } from '../../store';
import globalsSelectors from '../../globals/selectors';
import templateSelectors from '../selectors';

const isVariableGlobalsAvailable = (variableName) => {
  const store = connectedStore.get();
  const state = store.getState();
  const globals = globalsSelectors.getGlobals(state);
  const variable = templateSelectors.getVariableValueByPath(state, variableName);

  return (
    !!variable &&
    !!variable.length &&
    variable.every((varObj) => globals.some((global) => global.id === varObj.globalId))
  );
};

export default isVariableGlobalsAvailable;
